import { applyMiddleware, createStore } from 'redux';
import { createBrowserHistory } from 'history';
import thunkMiddleware from 'redux-thunk';
import { routerMiddleware } from 'connected-react-router';
import { createEpicMiddleware } from 'redux-observable';
import { composeWithDevTools } from 'redux-devtools-extension';
import * as Sentry from '@sentry/browser';

import rootEpic from '@f/services/epics';
import createRootReducer from '@f/services/reducers';
import { createAction } from '@f/services/actions';

import { SIGN_IN_FULFILL } from './services/authentication/authentication.actions';

const epicMiddleware = createEpicMiddleware();

export const history = createBrowserHistory({
  basename: '/',
});

const unauthorizedSignouter = store => next => action => {
  if (action.error && action.payload?.response?.status === 401) {
    store.dispatch(
      createAction(SIGN_IN_FULFILL, {
        isLoggedIn: false,
      })
    );
  }
  return next(action);
};

const errorReporter = store => next => action => {
  try {
    return next(action);
  } catch (error) {
    console.error('Error caught in Redux: %s', error.stack);
    Sentry.captureException(error, {
      extra: {
        action,
        state: store.getState(),
      },
    });

    return store.dispatch(createAction('ERROR', error));
  }
};

const withReduxDevTools = process.env.NODE_ENV === 'development' ? composeWithDevTools : e => e;

export default preloadedState => {
  const store = createStore(
    createRootReducer(history),
    preloadedState,
    withReduxDevTools(
      applyMiddleware(routerMiddleware(history), thunkMiddleware, epicMiddleware, unauthorizedSignouter, errorReporter)
    )
  );

  epicMiddleware.run(rootEpic);

  return store;
};
